<template lang="html">

  <section class="banner-somos-ahorro">

    <div class="container row-end">

      <video playsinline id="video" preload loop autoplay muted>
        <source :src="'/static/video/video-cerdo.mp4'" type="video/mp4">    
        </video>

        <div class="contenedor-texto">
          <h2>
            <span class="-orange">Somos</span>
            <span class="-dark">ahorro</span>
          </h2>
          <img src="/static/img/cerdo.webp" class="cerdo" alt="Imagen de Cerdo de ahorro">
          <h4 class="-dark">¿Quieres saber cuánto puedes ahorrar con Iner?</h4>
          <p>Con el dinero que vas a ahorrar con iner en tus facturas podrás llenar más rápido tu hucha. ¿A qué esperas para hacerlo?</p>
          <p>Estas a un solo paso de empezar a ahorrar.</p>
          <router-link class="btn -degree" :to="$t('enlaces.simulador')" title="Enlace a simulador"  aria-label="Enlace a simulador" >Calcular Ahorro</router-link>
        </div>
      </div>

    </section>

  </template>

  <script lang="js">
    export default  {
      name: 'banner-somos-ahorro'
    }
  </script>

  <style scoped lang="scss">
    .banner-somos-ahorro {
      position: relative;
    }


    .container{
      padding: 5vw 50px 10vw 50px;
      position: relative;
      max-width: 1140px;
    }

  .cerdo{
    display: none;
  }

    .contenedor-texto{
      max-width: 410px;
      width: 100%;
      text-align: left;
      position: relative;
      z-index: 2;

      p{
        margin: 10px 0;

        &:last-of-type{
          margin-top: 0;
        }
      }


      .btn{
        margin-top: 30px;
      }

    }

    #video{
      position: absolute;
      left: 0;
      top: 0;
      max-height: 100%;
      display: inline-block;
    }

    @media screen and (max-width: 1024px){
      #video{
        left: 50px;
      }
    }

    @media screen and (max-width: 950px){
      #video{left: -50px;}
    }

    @media screen and (max-width: 830px){
      .container{
        justify-content: flex-start;
      }

      .contenedor-texto{
        max-width: 50%;
      }

      #video{
        left: auto;
        right: 0;
      }
    }


    @media screen and (max-width: 630px){

      .contenedor-texto{
        max-width: 100%;
      }

      .container{
        padding-bottom: 20vw;
      }

      #video{
        transform: translateY(100px);
      }

    }

    @media screen and (max-width: 600px){
      #video{
        display: none;
      }

      .cerdo{
        display: inline-block;
        max-width: 100%;
      }

      .container{
        padding-bottom: 50px;
        padding-left: 15px;
        padding-right: 15px;
        justify-content: center;
        -webkit-justify-content: center;
      }

      .contenedor-texto{
        max-width: 350px;
        text-align: center;
        *{
          text-align: left;
        }
      }

      .contenedor-texto .btn{
        margin-top: 10px;
      }

    }

  </style>



// WEBPACK FOOTER //
// src/components/parts/banner-somos-ahorro.vue